import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveWinnersDrops } from "./drops/WaveWinnersDrops";
import { WaveWinnersPodium } from "./podium/WaveWinnersPodium";
import { WaveWinnersTimeline } from "./WaveWinnersTimeline";
import { FULL_APPROVAL_WAVE_DECISIONS_PAGE_SIZE, useWaveDecisions } from "@/hooks/waves/useWaveDecisions";
import { useLayout } from "@/components/brain/my-stream/layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { WaveWinnersApprovalError } from "./WaveWinnersApprovalError";
interface WaveWinnersProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveWinners: React.FC<WaveWinnersProps> = t0 => {
  const $ = _c(41);
  const {
    wave,
    onDropClick
  } = t0;
  const {
    decisions: t1
  } = useWave(wave);
  const {
    multiDecision
  } = t1;
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  const {
    winnersViewStyle
  } = useLayout();
  const t2 = isApproveWave ? FULL_APPROVAL_WAVE_DECISIONS_PAGE_SIZE : undefined;
  let t3;
  if ($[0] !== isApproveWave || $[1] !== t2 || $[2] !== wave.id) {
    t3 = {
      waveId: wave.id,
      enabled: true,
      loadAllPages: isApproveWave,
      pageSize: t2
    };
    $[0] = isApproveWave;
    $[1] = t2;
    $[2] = wave.id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    decisionPoints,
    isFetching,
    isLoadingAllPages,
    isLoadingAllPagesError,
    refetch,
    fetchNextPage,
    hasNextPage
  } = useWaveDecisions(t3);
  const isDecisionsLoading = isApproveWave ? isLoadingAllPages : isFetching;
  let t4;
  if ($[4] !== decisionPoints) {
    t4 = decisionPoints.flatMap(_temp);
    $[4] = decisionPoints;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const approvedWinners = t4;
  let t5;
  if ($[6] !== fetchNextPage || $[7] !== hasNextPage || $[8] !== refetch) {
    t5 = () => {
      if (hasNextPage) {
        fetchNextPage();
        return;
      }
      refetch();
    };
    $[6] = fetchNextPage;
    $[7] = hasNextPage;
    $[8] = refetch;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleApprovalWinnersRetry = t5;
  let winnersContent;
  if (isApproveWave && isLoadingAllPagesError) {
    let t6;
    if ($[10] !== handleApprovalWinnersRetry) {
      t6 = <div className="tw-mt-2 tw-flex-grow tw-pb-6 lg:tw-pr-2"><WaveWinnersApprovalError onRetry={handleApprovalWinnersRetry} /></div>;
      $[10] = handleApprovalWinnersRetry;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    winnersContent = t6;
  } else {
    if (isApproveWave) {
      let t6;
      if ($[12] !== approvedWinners || $[13] !== isDecisionsLoading || $[14] !== onDropClick || $[15] !== wave) {
        t6 = <div className="tw-mt-2 tw-flex-grow tw-space-y-2 tw-pb-6 lg:tw-pr-2"><WaveWinnersDrops wave={wave} onDropClick={onDropClick} winners={approvedWinners} isLoading={isDecisionsLoading} isApprovalWave={true} emptyMessage="No drops approved yet" /></div>;
        $[12] = approvedWinners;
        $[13] = isDecisionsLoading;
        $[14] = onDropClick;
        $[15] = wave;
        $[16] = t6;
      } else {
        t6 = $[16];
      }
      winnersContent = t6;
    } else {
      if (multiDecision) {
        let t6;
        if ($[17] !== decisionPoints || $[18] !== isDecisionsLoading || $[19] !== onDropClick || $[20] !== wave) {
          t6 = <WaveWinnersTimeline onDropClick={onDropClick} decisionPoints={decisionPoints} wave={wave} isLoading={isDecisionsLoading} />;
          $[17] = decisionPoints;
          $[18] = isDecisionsLoading;
          $[19] = onDropClick;
          $[20] = wave;
          $[21] = t6;
        } else {
          t6 = $[21];
        }
        winnersContent = t6;
      } else {
        let t6;
        if ($[22] !== decisionPoints[0]?.winners) {
          t6 = decisionPoints[0]?.winners ?? [];
          $[22] = decisionPoints[0]?.winners;
          $[23] = t6;
        } else {
          t6 = $[23];
        }
        let t7;
        if ($[24] !== isDecisionsLoading || $[25] !== onDropClick || $[26] !== t6) {
          t7 = <WaveWinnersPodium onDropClick={onDropClick} winners={t6} isLoading={isDecisionsLoading} />;
          $[24] = isDecisionsLoading;
          $[25] = onDropClick;
          $[26] = t6;
          $[27] = t7;
        } else {
          t7 = $[27];
        }
        let t8;
        if ($[28] !== decisionPoints[0]?.winners) {
          t8 = decisionPoints[0]?.winners ?? [];
          $[28] = decisionPoints[0]?.winners;
          $[29] = t8;
        } else {
          t8 = $[29];
        }
        let t9;
        if ($[30] !== isDecisionsLoading || $[31] !== onDropClick || $[32] !== t8 || $[33] !== wave) {
          t9 = <WaveWinnersDrops wave={wave} onDropClick={onDropClick} winners={t8} isLoading={isDecisionsLoading} />;
          $[30] = isDecisionsLoading;
          $[31] = onDropClick;
          $[32] = t8;
          $[33] = wave;
          $[34] = t9;
        } else {
          t9 = $[34];
        }
        let t10;
        if ($[35] !== t7 || $[36] !== t9) {
          t10 = <div className="tw-mt-2 tw-flex-grow tw-space-y-2 tw-pb-6 lg:tw-pr-2">{t7}{t9}</div>;
          $[35] = t7;
          $[36] = t9;
          $[37] = t10;
        } else {
          t10 = $[37];
        }
        winnersContent = t10;
      }
    }
  }
  let t6;
  if ($[38] !== winnersContent || $[39] !== winnersViewStyle) {
    t6 = <div className="tw-space-y-4 tw-overflow-y-auto tw-px-2 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 hover:tw-scrollbar-thumb-iron-300 lg:tw-space-y-6" style={winnersViewStyle}>{winnersContent}</div>;
    $[38] = winnersContent;
    $[39] = winnersViewStyle;
    $[40] = t6;
  } else {
    t6 = $[40];
  }
  return t6;
};
function _temp(point) {
  return point.winners;
}